<!-- 查看详情 -->
<template>
  <div class="apply" v-loading="loading">
    <back />
    <el-form :model="ruleForm" ref="ruleForm" label-width="155px" class="demo-ruleForm">
      <div class="form">
        <div class="title">基本信息:</div>
        <div class="container">
          <div class="item">项目名称：{{ ruleForm.projectName }}</div>
          <div class="item">项目分类：{{ ruleForm.secondCategoryName }}</div>
          <div class="item">服务时长（min）：{{ruleForm.durationMinute}}</div>
          <div class="item">定价（元）：{{ruleForm.price}}</div>
          <div class="item">划线价（元）：{{ruleForm.linePrice}}</div>
          <div class="item">次数：{{ruleForm.projectCount}}</div>
        </div>
        <div class="pic">
          项目图片：
          <div class="picbox"><el-image style="width: 100px; height: 100px; border-radius: 6px;" fit="cover" :src="(ruleForm.picList && ruleForm.picList.length > 0) ? ruleForm.picList[0] : ''" :preview-src-list="(ruleForm.picList && ruleForm.picList.length > 0) ? [ruleForm.picList[0]] : []">
            </el-image></div>
          <div class="picbox"><el-image style="width: 100px; height: 100px; border-radius: 6px;" fit="cover" :src="(ruleForm.picList && ruleForm.picList.length > 1) ? ruleForm.picList[1] : ''" :preview-src-list="(ruleForm.picList && ruleForm.picList.length > 1) ? [ruleForm.picList[1]] : []">
            </el-image></div>
          <div class="picbox"><el-image style="width: 100px; height: 100px; border-radius: 6px;" fit="cover" :src="(ruleForm.picList && ruleForm.picList.length > 2) ? ruleForm.picList[2] : ''" :preview-src-list="(ruleForm.picList && ruleForm.picList.length > 2) ? [ruleForm.picList[2]] : []">
            </el-image></div>
        </div>
        <el-divider></el-divider>
        <div class="title">项目详情:</div>
        <div class="container">
          <div class="item">服务部位：{{ruleForm.serviceLocation}}</div>
        </div>
        <div><span style=" font-size: 16px;color: #707070;">服务流程:</span>
          <div class="g_table" style="margin-top: 20px;">
            <el-table :data="tableData" style="width: 100%" max-height="540">
              <el-table-column min-width="100" show-overflow-tooltip prop="auditStatus" label="服务步骤">
                <template slot-scope="scope">
                  {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
                </template>
              </el-table-column>
              <el-table-column min-width="200" show-overflow-tooltip prop="processName" label="服务内容"></el-table-column>
              <el-table-column min-width="100" show-overflow-tooltip prop="durationMinute" label="服务时长(min)"></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="container">
          <div style="margin: 20px 0px 20px 0px;font-size: 16px;color: #707070;">注意事项：<span style="color: black;">{{ruleForm.explainDesc}}</span></div>
        </div>
        <div>
          <div style=" font-size: 16px;color: #707070;margin-bottom: 20px;">图文详情：</div>
          <div v-html="ruleForm.introduction" style="max-width: 1553px;"></div>
        </div>
        <el-divider></el-divider>
        <div class="title">提成信息:</div>
        <div class="container">
          <div class="item" v-if="ruleForm.commissionRate">员工提成比例(%)：{{ruleForm.commissionRate}}</div>
          <div class="item" v-if="ruleForm.commissionAmount">员工提成金额(元)：{{ruleForm.commissionAmount}}</div>
        </div>
        <el-divider></el-divider>
        <div class="title">分账信息:</div>
        <div class="g_table">
          <el-table :data="dataList" style="width: 100%" max-height="540">
            <el-table-column label="序号" show-overflow-tooltip width="80">
              <template slot-scope="scope">
                {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
              </template>
            </el-table-column>
            <el-table-column min-width="150" show-overflow-tooltip prop="storeName" label="门店名称"></el-table-column>
            <el-table-column min-width="150" show-overflow-tooltip prop="address" label="门店地址"></el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="storeRate" label="门店分账比例(%)"></el-table-column>
          </el-table>

        </div>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

        <el-divider></el-divider>
        <div class="title">审核信息:</div>
        <div class="container">
          <div class="item">申请时间：{{ruleForm.createdTime}}</div>
          <div class="item">审核时间：{{ruleForm.auditDate}}</div>
          <div class="item">审核状态：{{ruleForm.auditStatus==0?'待审核':ruleForm.auditStatus==1?'审核通过':'审核不通过'}}</div>
        </div>
        <div style="display: flex;margin-top: 10px; color: #707070;" v-if="ruleForm.auditStatus==2">
          <div>不通过原因：</div>
          <div v-html="ruleForm.auditMark"></div>
        </div>

      </div>
    </el-form>

  </div>
</template>

<script>
export default {
  data() {
    return {
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      loading: false,
      id: '',
      tableData: [],
      dataList: [],
      ruleForm: {
        supplierName: '', // 供应商名称
        serialId: '', // 商品编号
        barCode: '', // 商品条形码
        factoryName: '', // 厂家
        categoryName: '', // 商品类目
        productName: '', // 商品名称
        specs: '', // 规格
        validityPeriod: '', // 保质期
        shopName: '', // 店铺名称
        enterBox: '', // 入箱数
        brand: '', // 品牌
        supplyPrice: '', // 供货价
        salePrice: '', // 售货价
        linePrice: '', // 划线价

        picUrl: "", //商品图片
        productIntroduce: "", //介绍
      },
      currentPage: 1, // 当前页码
      pageSize: 5, // 每页显示的行数
      pageSizeArr: [5, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getDataList()
    this.getShopProductDetailById();
  },
  methods: {
    getShopProductDetailById() {
      this.loading = true;
      this.$axios.get(this.$api.selectProjectInfo, {
        params: {
          projectId: this.$route.query.projectId,
        }
      }).then((res) => {
        if (res.code == 100) {
          this.ruleForm = res.result
          this.tableData = res.result.processList
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },
    getDataList() {
      this.$axios.post(this.$api.selectProjectAccountList, {
        projectId: this.$route.query.projectId,
        page: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        this.dataList = res.result.list
        this.totalItemsCount = res.result.totalCount
        this.dataList.forEach(item => {
          // this.$set(item, 'disabled', true)
          // item.storeId = item.id
          item.storeRateDefault = item.storeRate
        })

      }).catch(error => {
        console.log(error)
      })
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getDataList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getDataList()
    },
  },

}
</script>

<style lang="scss" scoped>
.apply {
  // 1.基本信息
  .form {
    margin: 30px 20px;

    .title {
      font-size: 20px;
      margin-bottom: 30px;
      font-weight: bold;
    }
    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .item {
      width: 33%; /* 100% / 4 = 25%，留一点空间避免浏览器计算误差 */
      margin-bottom: 30px;
      font-size: 16px;
      color: #707070;
    }
  }
  .pic {
    color: #707070;
    display: flex;
    .picbox {
      margin-right: 20px;
    }
    .price {
      margin-right: 244px;
    }
  }
  .logo_pic {
    .busilicense {
      width: 180px;
      height: 120px;
      margin-right: 10px;
    }
  }

  .flex {
    display: flex;
  }

  .introduce {
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid rgba(3, 16, 14, 0.1);
    min-height: 40px;
    padding: 0 10px;

    ::v-deep img {
      max-width: 100%;
      height: auto;
    }
  }
}

// common
.dialog_row {
  // width: 850px;
  ::v-deep.el-form-item {
    margin-right: 100px;

    .el-input__inner {
      background: #ffffff;
      border-radius: 10px;
      border: 1px solid rgba(3, 16, 14, 0.1);
    }
  }

  ::v-deep.el-form-item__label {
    color: #272727;
    font-size: 16px;
    padding-right: 30px;
  }
}
</style>
